export default function initToggles() {
  const isPresent = document.querySelector("[data-toggle-element]");
  if (!isPresent) {
    return;
  }

  const toggles = document.querySelectorAll("[data-toggle-element]");
  const targets = document.querySelectorAll("[data-toggle-target]");

  function clearActives() {
    toggles.forEach((el) => {
      el.classList.remove("active");
    });
  }

  function clearWindows() {
    targets.forEach((el) => {
      el.classList.add("hidden");
    });
  }

  toggles.forEach((el) => {
    el.addEventListener("click", function () {
      clearActives();

      el.classList.toggle("active");

      const target = document.querySelector(
        `[data-toggle-target=${el.dataset.toggleElement}]`
      );

      if (!target.classList.contains("hidden")) {
        clearActives();
        target.classList.add("hidden");
      } else {
        clearWindows();
        target.classList.remove("hidden");

        // Scroll to the target element smoothly
        target.scrollIntoView({
          behavior: "smooth",
          block: "start",
        });
      }
    });
  });

  const closeButtons = document.querySelectorAll("[data-toggle-close]");

  closeButtons.forEach((el) => {
    el.addEventListener("click", function () {
      clearWindows();
      clearActives();
    });
  });

  // Add event listener for the 'Escape' key
  document.addEventListener("keydown", function (event) {
    if (event.key === "Escape") {
      clearWindows();
      clearActives();
    }
  });
}
